/* MYNTELO commerce (2026-10-19): the theme's own replacements for the Vitals app.
   1. Cart drawer   - registered as <cart-notification> so product-form.js, global.js upsells and Complete the set open it unchanged.
   2. Sticky add to bag on product pages - clicks the real Add to bag button, so bag totals, Complete the set and errors all still apply.
   3. Recent sales  - real orders and real add-to-carts only (sections/myntelo-storefront-tools.liquid), never invented.
   4. Country / currency picker submit, image protection, Microsoft Clarity loader (after analytics consent).
   v6.4 (2026-10-27): the drawer opens the moment an add to bag starts, with a loading line, then fills from the add's response;
   a failed add shows its message inside the drawer (initInstantBag). */
(function () {
  'use strict';
  var cfg = window.MynteloCommerce || {};
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SECTION = 'myntelo-cart-drawer';

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function sectionHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  /* 1. Cart drawer ------------------------------------------------------------------------------ */
  class MynteloCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.seq = 0;
      this.applied = 0;
      this.panel = this.querySelector('.m-drawer__panel');
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      document.addEventListener('click', this.onBagClick.bind(this));
      window.addEventListener('pageshow', function (e) { if (e.persisted) this.refresh(); }.bind(this));
    }

    get body() { return this.querySelector('.m-drawer__body'); }
    get isOpen() { return this.classList.contains('is-open'); }
    onCartPage() { return location.pathname.replace(/\/$/, '') === (this.dataset.cartUrl || '/cart').replace(/\/$/, ''); }

    /* API the theme's add-to-cart code expects from cart-notification */
    setActiveElement(el) { this.activeElement = el; }
    getSectionsToRender() { return [{ id: SECTION }, { id: 'cart-icon-bubble' }]; }
    renderContents(state) {
      var was = this.classList.contains('is-pending');
      this.unpend(true);
      this.render(state && state.sections, ++this.seq);
      this.open();
      if (was) this.added(state);
    }

    /* round 2: screen readers hear the result of the add, not only "Adding to your bag..." */
    added(state) {
      var st = this.querySelector('[data-drawer-status]'); if (!st) return;
      var items = state && (state.items || (state.product_title || state.title ? [state] : [])) || [];
      /* round 4: add-ons Complete the set added just before (snippets/myntelo-complete-set.liquid) */
      if (this._mxExtra) { items = items.concat(this._mxExtra); this._mxExtra = null; }
      var names = items.map(function (it) { return (it.product_title || it.title || '') + (it.variant_title && it.variant_title !== 'Default Title' ? ' (' + it.variant_title + ')' : ''); }).filter(Boolean);
      var text = names.length ? 'Added: ' + names.join(', ') + ' to your bag' : 'Added to your bag';
      st.textContent = '';
      setTimeout(function () { st.textContent = text; }, 60);
    }

    /* v6.4: instant feedback. pending() runs when an add that asks for this drawer's section starts (initInstantBag below):
       the drawer opens at once with a loading line on top of the bag; the caller's renderContents() then swaps in the real bag.
       settle() runs when the add answers: a refused add (sold out, limit, network) shows its message here; a good add that
       nobody renders within 1.2 s is fetched by the drawer itself. Lines and the foot wait (no taps) while the add is open. */
    pending(softMs) {
      if (this.onCartPage()) return;
      clearTimeout(this._pendT);
      /* round 2: pending(ms) from a tap that will start an add a moment later (collection quick-add sheet): if no add starts within
         ms, the drawer closes again. The add itself calls pending() without ms, which clears that timer. */
      clearTimeout(this._softT);
      var self0 = this;
      if (softMs) this._softT = setTimeout(function () { if (self0.classList.contains('is-pending')) { var s0 = self0.querySelector('[data-drawer-status]'); if (s0) s0.textContent = ''; self0.unpend(); self0.close(); } }, softMs);
      this.classList.add('is-pending');
      var b = this.body, err = this.querySelector('[data-drawer-error]'), st = this.querySelector('[data-drawer-status]');
      if (err) { err.hidden = true; err.textContent = ''; }
      var old = b && b.querySelector('[data-drawer-add-error]'); if (old) old.remove();
      if (b && !this.classList.contains('is-pending-slim') && !b.querySelector('.m-line--skel')) {
        var list = b.querySelector('.m-drawer__items'), skel = document.createElement(list ? 'li' : 'div');
        skel.className = 'm-line m-line--skel';
        skel.setAttribute('aria-hidden', 'true');
        skel.innerHTML = '<span class="m-line__img"></span><span class="m-line__info"><span class="m-skel__t">Adding to your bag…</span><span class="m-skel__bar"></span><span class="m-skel__bar m-skel__bar--s"></span></span>';
        if (list) { list.insertBefore(skel, list.firstChild); list.scrollTop = 0; }
        else { var head = b.querySelector('.m-drawer__head'); if (head) head.insertAdjacentElement('afterend', skel); }
      }
      if (st) st.textContent = 'Adding to your bag…';
      this.open();
      var self1 = this;
      requestAnimationFrame(function () {
        var sk = self1.classList.contains('is-pending') && self1.body && self1.body.querySelector('.m-drawer__items > .m-line--skel');
        var line = sk && sk.parentNode.querySelector('.m-line:not(.m-line--skel)');
        if (line && line.getBoundingClientRect().bottom > sk.parentNode.getBoundingClientRect().bottom + 1) { sk.remove(); self1.classList.add('is-pending-slim'); }
      });
    }

    settle(ok, msg) {
      var self = this;
      if (!this.classList.contains('is-pending')) return;
      if (ok) {
        this._pendT = setTimeout(function () { if (self.classList.contains('is-pending')) { self.unpend(); self.refresh().then(function () { self.added(null); }); } }, 1200);
        return;
      }
      this.unpend();
      var text = msg || 'We couldn’t add that to your bag. Please try again.';
      this.showAddError(text);
      /* round 5: part of the add may have gone through (Complete the set adds the add-ons first): re-read the bag, keep the message */
      this.refresh().then(function () { if (!self.classList.contains('is-pending')) self.showAddError(text, true); });
    }

    showAddError(text, quiet) {
      var el = this.querySelector('[data-drawer-error]');
      if (!el && this.body) {
        el = document.createElement('p');
        el.className = 'm-drawer__error m-drawer__error--add';
        el.setAttribute('data-drawer-add-error', '');
        var head = this.body.querySelector('.m-drawer__head');
        if (head) head.insertAdjacentElement('afterend', el); else this.body.prepend(el);
      }
      /* re-shown after the re-read (quiet): announced once already, so no alert role this time */
      if (el) { if (quiet) el.removeAttribute('role'); else el.setAttribute('role', 'alert'); el.textContent = text; el.hidden = false; }
      if (quiet) return;
      var st = this.querySelector('[data-drawer-status]'); if (st) st.textContent = text;
    }

    // keepSkeleton: a render follows at once and replaces the whole body (skeleton included); removing the skeleton separately first
    // made two DOM mutations in one task, which Microsoft Clarity's recorder sometimes trips over ("reading 'sequence'").
    unpend(keepSkeleton) {
      clearTimeout(this._pendT); clearTimeout(this._softT);
      this.classList.remove('is-pending', 'is-pending-slim');
      if (keepSkeleton) return;
      this._mxExtra = null;
      var sk = this.body && this.body.querySelector('.m-line--skel'); if (sk) sk.remove();
      /* round 5: the split-ship line skips a loading drawer (snippets/myntelo-split-ship.liquid); no re-render follows here */
      if (window.mxSplitShip) window.mxSplitShip.refresh();
    }

    /* v6.3 (2026-10-23): the bag's live line (sections/myntelo-cart-drawer.liquid, data-m-pulse). Real data only; any doubt or error
       leaves the notice. Orders: a product's newest order (Flow metafield, newest only) inside 7 days -> "Ordered this week".
       Add-to-carts: this week's events from the "Count add-to-carts from" moment, without this shopper's own adds, per product
       handle -> "Added to N bags this week". One lookup per session (sessionStorage), only once the bag shows items. */
    pulse() {
      var el = this.querySelector('[data-m-pulse]');
      if (!el || el._mp) return;
      el._mp = 1;
      var items, txt = el.querySelector('[data-m-pulse-text]');
      try { items = JSON.parse(el.getAttribute('data-m-pulse')) || []; } catch (_) { return; }
      if (!txt || !items.length) return;
      var now = Date.now(), WEEK = 7 * 864e5, many = items.length > 1;
      function put(it, line) {
        var h = el.offsetHeight; if (h) el.style.minHeight = h + 'px'; // the drawer is open: keep the box, swap only the words
        txt.textContent = '🔥 ' + (many ? it.n + ': ' + line.charAt(0).toLowerCase() + line.slice(1) : line);
      }
      var ordered = items.filter(function (it) { var t = Date.parse(it.o || ''); return t && t <= now + 6e5 && now - t <= WEEK; });
      if (ordered.length) { put(ordered[0], 'Ordered this week'); return; }
      var since = Date.parse(el.getAttribute('data-atc-since') || '');
      if (!since || !atc()) return;
      weekAdds().then(function (rows) {
        if (!rows || !D2.contains(el)) return;
        var from = Math.max(since, now - WEEK), own = mine(), n = {};
        var oldest = rows.length ? Date.parse(rows[rows.length - 1].added_at) : now;
        if (rows.length >= 50 && oldest > from) return; // full page (the RPC returns at most 50 rows today): a count could be short, so say nothing
        rows.forEach(function (r) {
          var t = Date.parse(r.added_at);
          if (!r.handle || !t || t < from || t > now + 6e5) return;
          if (own.some(function (m) { return m.h === r.handle && Math.abs(m.t - t) < 12e4; })) return;
          n[r.handle] = (n[r.handle] || 0) + 1;
        });
        var best = null;
        items.forEach(function (it) { if (n[it.h] && (!best || n[it.h] > n[best.h])) best = it; });
        if (best) put(best, 'Added to ' + n[best.h] + (n[best.h] === 1 ? ' bag' : ' bags') + ' this week');
      }).catch(function () {});
    }
    renderUpsellContents(state) { this.renderContents(state); }

    // seq: every request takes a number when it starts; a response older than the last one applied is dropped,
    // so a slow refresh can't overwrite a newer quantity change or add.
    render(sections, seq) {
      if (seq !== undefined) { if (seq < this.applied) return; this.applied = seq; }
      if (!sections || !sections[SECTION]) { this.refresh(); return; }
      var body = sectionHTML(sections[SECTION], '.m-drawer__body');
      if (body !== null && body !== this.body.innerHTML) {
        // Keep keyboard focus on the same control across the swap (or the nearest sensible one).
        var active = document.activeElement, inside = active && this.body.contains(active);
        var key = inside && active.dataset.lineKey, label = inside && active.getAttribute('aria-label');
        this.body.innerHTML = body;
        if (this.isOpen) this.pulse();
        if (inside) {
          var same = key && label && this.body.querySelector('[data-line-key="' + CSS.escape(key) + '"][aria-label="' + CSS.escape(label) + '"]');
          var next = same || this.body.querySelector('[data-line-key]') || this.body.querySelector('.m-drawer__empty a') || this.body.querySelector('.m-drawer__close');
          if (next) next.focus();
        }
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        var inner = sectionHTML(sections['cart-icon-bubble'], '.shopify-section');
        if (inner !== null) bubble.innerHTML = inner;
      }
    }

    refresh() {
      if (this.busy) return Promise.resolve();
      var self = this, n = ++this.seq;
      return fetch(location.pathname + '?sections=' + SECTION + ',cart-icon-bubble', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (s) { if (s && s[SECTION]) self.render(s, n); })
        .catch(function () {});
    }

    open() {
      if (this.onCartPage()) { location.reload(); return; }
      this.pulse();
      if (!this.activeElement) this.activeElement = document.activeElement;
      this.hidden = false;
      document.documentElement.classList.add('m-drawer-lock');
      void this.offsetWidth; // apply display before the class so the slide-in transition runs
      this.classList.add('is-open');
      (this.querySelector('.m-drawer__close') || this.panel).focus({ preventScroll: true });
    }

    close() {
      if (!this.isOpen) return;
      var self = this;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('m-drawer-lock');
      if (this.activeElement && this.activeElement.focus && document.contains(this.activeElement)) this.activeElement.focus();
      this.activeElement = null;
      setTimeout(function () { if (!self.isOpen) self.hidden = true; }, reduce ? 0 : 380);
    }

    // Escape closes; Tab stays inside the panel. Focusables are read on each key press because re-renders replace them.
    onKeydown(e) {
      if (e.key === 'Escape') { this.close(); return; }
      if (e.key !== 'Tab' || !this.isOpen) return;
      var els = Array.prototype.filter.call(this.panel.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
      if (!els.length) return;
      var first = els[0], last = els[els.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    onBagClick(e) {
      var bag = e.target.closest && e.target.closest('#cart-icon-bubble');
      if (!bag || this.onCartPage() || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      this.activeElement = bag;
      this.open();
      this.refresh();
    }

    onClick(e) {
      if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); this.close(); return; }
      var btn = e.target.closest('[data-line-key]');
      if (btn) { e.preventDefault(); btn.focus(); this.change(btn.dataset.lineKey, parseInt(btn.dataset.qty, 10), btn); }
    }

    change(key, qty, btn) {
      if (this.busy || isNaN(qty) || qty < 0) return;
      var self = this, line = btn.closest('.m-line'), n = ++this.seq;
      this.busy = true;
      this.body.setAttribute('aria-busy', 'true');
      if (line) line.classList.add('is-busy');
      var url = ((window.routes && window.routes.cart_change_url) || root() + 'cart/change') + '.js';
      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: qty, sections: [SECTION, 'cart-icon-bubble'], sections_url: location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) {
            if (line) line.classList.remove('is-busy');
            self.showError(res.j.description || res.j.message || 'We couldn’t update your bag. Please try again.');
            return;
          }
          self.render(res.j.sections, n);
          self.announce();
        })
        .catch(function () {
          if (line) line.classList.remove('is-busy');
          self.showError('We couldn’t update your bag. Check your connection and try again.');
        })
        .finally(function () { self.busy = false; self.body.removeAttribute('aria-busy'); });
    }

    announce() {
      var status = this.querySelector('[data-drawer-status]'), count = this.querySelector('.m-drawer__count'), total = this.querySelector('.m-drawer__total span:last-child');
      if (status) status.textContent = count && total ? 'Bag updated: ' + count.textContent + ', subtotal ' + total.textContent : 'Your bag is empty.';
    }

    showError(msg) {
      var el = this.querySelector('[data-drawer-error]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
    }
  }
  if (!customElements.get('cart-notification')) customElements.define('cart-notification', MynteloCartDrawer);

  /* 2. Sticky add to bag ------------------------------------------------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-m-sticky]');
    if (!bar) return;
    var form = document.querySelector('#MainContent product-form form');
    var main = form && form.querySelector('button[type="submit"][name="add"], button[type="submit"]');
    if (!form || !main) { bar.remove(); return; }
    var btn = bar.querySelector('[data-m-sticky-btn]'), label = bar.querySelector('[data-m-sticky-label]');
    var priceEl = bar.querySelector('[data-m-sticky-price]'), variantEl = bar.querySelector('[data-m-sticky-variant]');
    var imgWrap = bar.querySelector('[data-m-sticky-img]'), variants = {};
    try { variants = JSON.parse(bar.querySelector('[data-m-sticky-variants]').textContent); } catch (_) {}
    var idInput = form.querySelector('[name="id"]');
    var mainLabel = main.querySelector('span') || main;

    function choosing() { return main.hasAttribute('data-mx-choose'); }   // v5.9: no Model picked yet (sections/main-product.liquid)
    function syncButton() {
      var disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
      btn.disabled = main.disabled && !choosing();
      btn.classList.toggle('loading', main.classList.contains('loading'));
      btn.setAttribute('aria-disabled', disabled && !choosing() ? 'true' : 'false');
      var t = (mainLabel.textContent || '').replace(/\s+/g, ' ').trim();
      if (t && label.textContent !== t) label.textContent = t;
    }
    function syncVariant() {
      var v = idInput && variants[idInput.value];
      if (!v || choosing()) return;
      if (variantEl && v.t !== 'Default Title') variantEl.textContent = v.t;
      if (priceEl) priceEl.textContent = v.p;
      var img = imgWrap && imgWrap.querySelector('img');
      if (img && v.i) { img.src = v.i; img.removeAttribute('srcset'); }
    }
    new MutationObserver(syncButton).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
    document.addEventListener('change', function () { setTimeout(syncVariant, 0); });
    document.addEventListener('variant:change', function () { setTimeout(syncVariant, 0); });
    syncButton();
    syncVariant();

    btn.addEventListener('click', function () {
      if (choosing()) {
        // v6.0: phones get the model sheet (assets/myntelo-flow.js); the dropdown is brought into view behind it as before.
        if (window.MynteloPicker && window.MynteloPicker.open()) return;
        var pick = form.closest('section') && form.closest('section').querySelector('variant-selects select');
        var spot = pick && (pick.closest('.product-form__input') || pick);
        if (spot) spot.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () {
          // Smooth scrolling can stall (background tab, throttled frames): if the picker is still off screen, jump to it.
          var r = spot && spot.getBoundingClientRect();
          if (r && (r.bottom < 0 || r.top > window.innerHeight)) spot.scrollIntoView({ behavior: 'instant', block: 'center' });
          if (pick) { try { pick.focus({ preventScroll: true }); } catch (_) { pick.focus(); } }
        }, reduce ? 0 : 450);
        return;
      }
      if (main.disabled || main.getAttribute('aria-disabled') === 'true') return;
      fromSticky = true;
      main.click();
      setTimeout(function () { fromSticky = false; }, 4000);
    });
    // A failed add shows its message beside the real button: bring it into view.
    var fromSticky = false;
    var err = form.closest('product-form') && form.closest('product-form').querySelector('.product-form__error-message-wrapper');
    if (err) new MutationObserver(function () { if (!err.hidden && fromSticky) err.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }).observe(err, { attributes: true, attributeFilter: ['hidden'] });

    liftChat();

    // v6.0b (2026-10-21) phones: the bar is up only while BOTH the Model select and the main Add to bag are fully off screen
    // (above or below), so it never covers them and never doubles them; hidden over the footer. The first screen holds the
    // real select + button (assets/myntelo-mobile.css). Larger screens keep the v5 rule (only once scrolled past the button).
    var phone = window.matchMedia('(max-width: 749px)');
    var past = false, atcIn = true, selIn = false, footerIn = false;
    function paint() {
      var on = phone.matches ? (!atcIn && !selIn && !footerIn) : (past && !footerIn);
      bar.classList.toggle('is-on', on);
      document.documentElement.classList.toggle('m-sticky-on', on);
      // v6.0 phones: the chat bubble / sign-up teaser wait until the visitor is past the buy box (assets/myntelo-mobile.css)
      document.documentElement.classList.toggle('m-buybox-view', phone.matches && !past && !footerIn);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { past = !e.isIntersecting && e.boundingClientRect.top < 0; atcIn = e.isIntersecting; });
        paint();
      }).observe(main);
      var selEl = form.closest('section') && form.closest('section').querySelector('variant-selects select');
      var selBox = selEl && (selEl.closest('.product-form__input') || selEl);
      if (selBox && selBox.offsetParent !== null) new IntersectionObserver(function (es) { selIn = es[0].isIntersecting; paint(); }).observe(selBox);
      var foot = document.querySelector('.m-footer');
      if (foot) new IntersectionObserver(function (es) { footerIn = es[0].isIntersecting; paint(); }).observe(foot);
    }
  }

  // Shopify Inbox's chat button sits bottom-right on phones; lift it above the sticky bar.
  function liftChat() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var tries = 0, t = setInterval(function () {
      var c = document.querySelector('shopify-chat'), sr = c && c.shadowRoot;
      if (sr && !sr.querySelector('#mx-chat-lift')) {
        var st = document.createElement('style');
        st.id = 'mx-chat-lift';
        st.textContent = '.activator-nudge{bottom:112px!important}';
        sr.appendChild(st);
      }
      if ((sr && sr.querySelector('#mx-chat-lift')) || ++tries > 40) clearInterval(t);
    }, 500);
  }

  /* 3. Recent sales notifications (real events only, never invented) ----------------------------
     Rebuilt 2026-10-20 to match the Vitals Recent Sales Notifications behaviour (Rounded Picture layout):
     purchases first, newest first, then add-to-cart events; 8 s before the first, 8 s on screen, 12 s between,
     6 per session; nothing older than the window shows; events this visitor already saw go to the back for 2 days.
     Purchases: product metafield myntelo.recent_sale, written by the Shopify Flow "MYNTELO recent sales".
     Add-to-carts: Supabase table public.cart_events (product handle + time only), through two RPCs.
     v7 (2026-11-02, Danny: kept but PITAKA-quiet): at most 2 per session, the first 15 s after load at the earliest,
     at least 60 s between cards (also across pages), 6 s on screen, never while a 3D stage (.m3d__stage, .m3x__stage)
     is in view (retried after the gap), never with prefers-reduced-motion. window.__mynSale exposes the numbers. */
  var SALE_FIRST = 15000, SALE_ON = 6000, SALE_GAP = 60000, SALE_PER_SESSION = 2, SALE_SEEN_MS = 2 * 864e5;
  // v6.0 phones: the first card waits 20 s and a visit sees at most 2, so the first screen is the product and the buy box.
  var phoneSale = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  if (phoneSale) { SALE_FIRST = 20000; SALE_PER_SESSION = 2; }
  // v7: no card while a 3D product stage is on screen (measured at show time).
  function stageInView() {
    var st = document.querySelectorAll('.m3d__stage, .m3x__stage'), vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < st.length; i++) {
      var r = st[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < vh) return true;
    }
    return false;
  }
  function box(storage) {
    return {
      get: function (k) { try { return window[storage].getItem(k); } catch (_) { return null; } },
      set: function (k, v) { try { window[storage].setItem(k, v); } catch (_) {} }
    };
  }
  var session = box('sessionStorage'), local = box('localStorage');
  function readJSON(s, k, d) { try { return JSON.parse(s.get(k)) || d; } catch (_) { return d; } }

  function atc() { var a = cfg.atc; return a && a.url && a.key ? a : null; }
  function rpc(name, body) {
    var a = atc(), headers = { apikey: a.key, 'Content-Type': 'application/json' };
    if (a.key.indexOf('sb_') !== 0) headers.Authorization = 'Bearer ' + a.key; // legacy anon JWT
    return fetch(a.url.replace(/\/$/, '') + '/rest/v1/rpc/' + name, { method: 'POST', headers: headers, body: JSON.stringify(body || {}), keepalive: true });
  }

  var D2 = document;
  // This week's add-to-cart events for the bag line: one lookup per session, shared by every drawer render.
  var addsP = null;
  function weekAdds() {
    if (addsP) return addsP;
    var c = readJSON(session, 'm_atc7', null);
    if (c && c.rows && Date.now() - c.at < 30 * 6e4) return (addsP = Promise.resolve(c.rows));
    addsP = rpc('recent_cart_events', { p_days: 7, p_limit: 500 })
      .then(function (r) { if (!r.ok) throw new Error('rpc ' + r.status); return r.json(); })
      .then(function (rows) { rows = Array.isArray(rows) ? rows : null; if (rows) session.set('m_atc7', JSON.stringify({ at: Date.now(), rows: rows })); return rows; })
      .catch(function () { return null; });
    return addsP;
  }
  // This visitor's own add-to-carts: logged for everyone else, never shown back to them.
  function mine() {
    var now = Date.now();
    return readJSON(local, 'm_atc_mine', []).filter(function (m) { return m && now - m.t < SALE_SEEN_MS; });
  }
  /* v6.3 (2026-10-22, Michael): only real shoppers on the published theme feed "Someone added to cart". Preview and editor
     sessions (theme role other than main, design mode) and automated browsers (navigator.webdriver, our headless tests) never
     log, so test traffic can't turn into social proof. */
  function realShopper() {
    var S = window.Shopify || {};
    return !!(S.theme && S.theme.role === 'main') && !S.designMode && navigator.webdriver !== true;
  }
  function logCart(handle) {
    if (!realShopper()) return;
    var list = mine(); list.push({ h: handle, t: Date.now() });
    local.set('m_atc_mine', JSON.stringify(list.slice(-30)));
    rpc('log_cart_event', { p_handle: handle }).catch(function () {});
  }
  // Every add to bag in the theme (product form, sticky bar, upsells, Complete the set) posts to /cart/add;
  // read the handles from its response, so only adds that succeeded are logged.
  function initCartEvents() {
    if (!atc() || !window.fetch) return;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var p = orig.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url)) {
          p.then(function (r) {
            if (!r.ok) return;
            r.clone().json().then(function (j) {
              var items = j && (j.items || (j.handle ? [j] : [])), done = {};
              (items || []).forEach(function (it) { if (it && it.handle && !done[it.handle]) { done[it.handle] = 1; logCart(it.handle); } });
            }).catch(function () {});
          }).catch(function () {});
        }
      } catch (_) {}
      return p;
    };
  }

  function initSales() {
    var el = document.getElementById('MSale'), dataEl = document.getElementById('MSalesData');
    var stat = window.__mynSale = { shown: parseInt(session.get('m_sale_n') || '0', 10), perSession: SALE_PER_SESSION, gapMs: SALE_GAP, firstMs: SALE_FIRST };
    if (!el || !dataEl || session.get('m_sale_off') === '1' || reduce) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (_) { return; }
    if (data.hideMobile && window.matchMedia('(max-width: 749px)').matches) return;
    var shown = parseInt(session.get('m_sale_n') || '0', 10);
    if (shown >= SALE_PER_SESSION) return;

    var now = Date.now(), maxAge = (data.days || 60) * 864e5;
    function fresh(s) { return s.ts && s.ts <= now + 6e5 && now - s.ts <= maxAge; }
    function newest(a, b) { return b.ts - a.ts; }
    var orders = (data.sales || []).map(function (s) { return { k: 'o', h: s.h, t: s.t, u: s.u, i: s.i, c: s.c, r: s.r, ts: Date.parse(s.at) }; })
      .filter(fresh).sort(newest);

    var seen = readJSON(local, 'm_sale_seen', {});
    Object.keys(seen).forEach(function (k) { if (now - seen[k] > SALE_SEEN_MS) delete seen[k]; });
    function id(s) { return s.k + ':' + s.h + ':' + s.ts; }
    var queue = [], qi = 0, timer, started = false;

    function build(carts) {
      var all = orders.concat(carts);
      queue = all.filter(function (s) { return !seen[id(s)]; }).concat(all.filter(function (s) { return seen[id(s)]; }));
    }

    function title(s) { s = String(s || ''); if (s !== s.toUpperCase() && s !== s.toLowerCase()) return s; return s.toLowerCase().replace(/(^|[\s\-'.])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }
    function ago(ts) {
      var m = Math.max(1, Math.round((Date.now() - ts) / 6e4));
      if (m < 60) return m + (m === 1 ? ' minute' : ' minutes') + ' ago';
      var h = Math.round(m / 60);
      if (h < 24) return h + (h === 1 ? ' hour' : ' hours') + ' ago';
      var d = Math.round(h / 24);
      return d + (d === 1 ? ' day' : ' days') + ' ago';
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML.replace(/"/g, '&quot;'); }
    function sized(src) { if (!src) return null; src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=180'; }

    // Add-to-cart events carry only a handle; title, link and image come from the store's own product JSON.
    // v7 iter 3a (2026-11-03): a handle whose product JSON is not ok (renamed or deleted product, e.g. the old
    // lucent-magsafe-tough-phone-case) is remembered in sessionStorage m_sale_bad and never fetched again this session.
    function badList() { var b = readJSON(session, 'm_sale_bad', []); return Array.isArray(b) ? b : []; }
    function product(s) {
      if (s.t) return Promise.resolve(s);
      if (!s.h || badList().indexOf(s.h) > -1) return Promise.resolve(null);
      return fetch(root() + 'products/' + encodeURIComponent(s.h) + '.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (r.ok) return r.json();
          var b = badList(); if (b.indexOf(s.h) < 0) { b.push(s.h); session.set('m_sale_bad', JSON.stringify(b.slice(-50))); }
          return null;
        })
        .then(function (p) {
          if (!p || !p.title) return null;
          s.t = p.title; s.u = p.url || root() + 'products/' + s.h; s.i = sized(p.featured_image);
          return s;
        })
        .catch(function () { return null; });
    }

    function next() {
      if (shown >= SALE_PER_SESSION || qi >= queue.length) return;
      if (document.hidden) { document.addEventListener('visibilitychange', function again() { document.removeEventListener('visibilitychange', again); timer = setTimeout(next, 4000); }); return; }
      var de = document.documentElement;
      if (de.classList.contains('m-drawer-lock') || de.classList.contains('mx-sheet-open') || (phoneSale && de.classList.contains('m-sticky-on'))) { timer = setTimeout(next, SALE_GAP); return; }
      if (stageInView()) { timer = setTimeout(next, SALE_GAP); return; }
      var s = queue[qi++];
      product(s).then(function (p) { if (p) render(p); else next(); });
    }

    function render(s) {
      if (shown >= SALE_PER_SESSION) return;
      if (stageInView()) { qi--; timer = setTimeout(next, SALE_GAP); return; } // the stage scrolled in while the product loaded
      var lead;
      if (s.k === 'a') lead = 'Someone added to cart';
      else { var place = [title(s.c), s.r].filter(Boolean).join(', '); lead = place ? 'Someone from ' + esc(place) + ' purchased' : 'Someone purchased'; }
      el.innerHTML =
        '<a class="m-sale__link" href="' + esc(s.u) + '">' +
          '<span class="m-sale__img">' + (s.i ? '<img src="' + esc(s.i) + '" width="90" height="90" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="m-sale__text">' +
            '<span class="m-sale__lead">' + lead + '</span>' +
            '<span class="m-sale__title">' + esc(s.t) + '</span>' +
            '<span class="m-sale__time">' + ago(s.ts) + '</span>' +
          '</span></a>' +
        '<button type="button" class="m-sale__close" aria-label="Close">×</button>';
      el.hidden = false;
      // v6.0b phones: the card sits fully below the header, measured now (the header is sticky, so its bottom moves with scroll)
      if (phoneSale) { var hd = document.querySelector('.m-header'), hb = hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0; el.style.top = Math.round(hb + 8) + 'px'; }
      void el.offsetWidth;
      el.classList.add('is-on');
      document.documentElement.classList.add('m-sale-on');
      shown++;
      stat.shown = shown;
      session.set('m_sale_n', String(shown));
      session.set('m_sale_at', String(Date.now()));
      seen[id(s)] = Date.now();
      local.set('m_sale_seen', JSON.stringify(seen));
      timer = setTimeout(hide, SALE_ON);
    }

    function hide(final) {
      el.classList.remove('is-on');
      document.documentElement.classList.remove('m-sale-on');
      setTimeout(function () { if (!el.classList.contains('is-on')) el.hidden = true; }, reduce ? 0 : 500);
      if (final !== true) timer = setTimeout(next, SALE_GAP);
    }

    el.addEventListener('click', function (e) {
      if (!e.target.closest('.m-sale__close')) return;
      e.preventDefault();
      clearTimeout(timer);
      session.set('m_sale_off', '1');
      hide(true);
    });
    el.addEventListener('mouseenter', function () { if (el.classList.contains('is-on')) clearTimeout(timer); });
    el.addEventListener('mouseleave', function () { if (el.classList.contains('is-on')) timer = setTimeout(hide, 3000); });

    function start(carts) {
      if (started) return;
      started = true;
      build(carts || []);
      if (!queue.length) return;
      // The first card waits SALE_FIRST after the load event, and SALE_GAP after the last card (an earlier page included).
      function arm() {
        var last = parseInt(session.get('m_sale_at') || '0', 10) || 0;
        var wait = Math.max(SALE_FIRST, last ? last + SALE_ON + SALE_GAP - Date.now() : 0);
        timer = setTimeout(next, wait);
      }
      if (document.readyState === 'complete') arm(); else window.addEventListener('load', arm, { once: true });
    }
    if (data.atc && atc()) {
      var own = mine();
      rpc('recent_cart_events', { p_days: data.days || 60, p_limit: 20 })
        .then(function (r) { return r.ok ? r.json() : []; })
        .then(function (rows) {
          start((Array.isArray(rows) ? rows : []).map(function (x) { return { k: 'a', h: x.handle, ts: Date.parse(x.added_at) }; })
            .filter(function (s) { return s.h && fresh(s) && !own.some(function (m) { return m.h === s.h && Math.abs(m.t - s.ts) < 12e4; }); })
            .sort(newest));
        })
        .catch(function () { start([]); });
      setTimeout(function () { start([]); }, SALE_FIRST); // a slow or failed lookup never holds back the purchases
    } else {
      start([]);
    }
  }

  /* 4a. Country / currency picker ---------------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-m-locale]');
    if (sel && sel.form) sel.form.submit();
  });

  /* 4b. Image protection ------------------------------------------------------------------------- */
  if (cfg.protect) {
    document.documentElement.classList.add('m-protect');
    var media = 'img, picture, canvas, video, model-viewer, .m-card__image, .product__media';
    document.addEventListener('contextmenu', function (e) { if (e.target.closest && e.target.closest(media)) e.preventDefault(); });
    document.addEventListener('dragstart', function (e) { if (e.target.closest && e.target.closest('img, picture')) e.preventDefault(); });
  }

  /* 4c. Microsoft Clarity, only once the visitor allows analytics ------------------------------- */
  function initClarity() {
    var id = cfg.clarity;
    if (!id || !/^[a-z0-9]{6,20}$/i.test(id)) return;
    var loaded = false;
    function load() {
      if (loaded) return;
      loaded = true;
      later(inject);
    }
    // v6.0: the recorder waits for the first touch / scroll / key, or 4 s after the page has loaded, so it never competes with first paint.
    function later(fn) {
      var done = false, evs = ['pointerdown', 'scroll', 'keydown', 'touchstart'];
      function go() { if (done) return; done = true; evs.forEach(function (n) { window.removeEventListener(n, go, true); }); fn(); }
      evs.forEach(function (n) { window.addEventListener(n, go, { capture: true, passive: true, once: true }); });
      function timed() { setTimeout(go, 4000); }
      if (document.readyState === 'complete') timed(); else window.addEventListener('load', timed, { once: true });
    }
    function inject() {
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      })(window, document, 'clarity', 'script', id);
      window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'granted' });
    }
    function check() {
      var cp = window.Shopify && Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()) load();
    }
    document.addEventListener('visitorConsentCollected', function (e) { if (e.detail && e.detail.analyticsAllowed) load(); });
    if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) check(); });
    } else {
      check();
    }
  }

  /* v6.4 (2026-10-27): every add to bag that asks for the drawer's section (product form + sticky bar + Complete the set in
     product-form.js, collection quick-add, Live Case, Instagram feed) opens the drawer the moment it starts. Adds without it
     (Buy now -> checkout) are left alone. Only watches the request; the callers keep their own handling and logging. */
  function wantsDrawer(body) {
    try {
      if (!body) return false;
      if (typeof body === 'string') return body.indexOf(SECTION) > -1;
      if (typeof body.get === 'function') return String(body.get('sections') || '').indexOf(SECTION) > -1;
    } catch (_) {}
    return false;
  }
  function initInstantBag() {
    if (!window.fetch) return;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var drawer = null;
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url) && wantsDrawer(init && init.body)) {
          drawer = document.querySelector('cart-notification');
          if (drawer && typeof drawer.pending === 'function') drawer.pending(); else drawer = null;
        }
      } catch (_) { drawer = null; }
      var p = orig.apply(this, arguments);
      if (drawer) {
        p.then(function (r) {
          if (r.ok) { drawer.settle(true); return; }
          r.clone().json().then(function (j) { drawer.settle(false, j && (j.description || j.message)); }, function () { drawer.settle(false); });
        }, function () { drawer.settle(false, 'We couldn’t add that. Check your connection and try again.'); });
      }
      return p;
    };
  }

  initInstantBag();
  initCartEvents(); // before other scripts' first add to bag
  ready(function () { initSticky(); initSales(); initClarity(); });
})();
